import Page from '@/next/components/Page/Page';

export default Page;
